import type { ReactNode } from "react";

/** Clearly marked placeholder for missing source or country-specific content. */
export function Placeholder({
  children
}: {
  children: ReactNode;
}) {
  return <span className="inline rounded-[3px] border border-dashed border-amber/50 bg-amber-soft px-1 py-px text-[0.92em] text-amber [box-decoration-break:clone]" data-id="element-178" data-mp="jsxfnfr5xxld">
      [Placeholder: {children}]
    </span>;
}